export const generateTrackingLink = (description: string, trackingNumber: string) => {
    if (description.includes("Fedex")) {
        return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;
    } else if (description.includes("UPS")) {
        return `https://www.ups.com/track?track=yes&trackNums=${trackingNumber}`;
    }
    return;
}
